<template>
    <div>
        <div class="banner-container">
            <img class="career-img" src="../../assets/image/career/career-banner.jpg" />
            <p class="join-title">Join Our Team</p>
        </div>
        <el-breadcrumb class="breadcrumb-container" separator="/">
            <el-breadcrumb-item class="breadcrumb-item" :to="{ path: '/career' }">Career</el-breadcrumb-item>
            <el-breadcrumb-item class="breadcrumb-item">Senior Risk & Compliance Officer</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="job-container">
            <p class="title">Senior Risk & Compliance Officer</p>
            <div class="description-container">
                <p class="subtitle">Job Requirements</p>
                <ul class="requirement-list">
                    <li> General Risk and Compliance Management:</li>
                    <li class="list-details"> At least 1 year experience in banking or fintech industry related to legal, risk or compliance.</li>
                    <li class="list-details"> Knowledge in investigation, research and data analytics.</li>
                    <li class="list-details"> Good in Khmer and English. Chinese is a plus.</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">Job Description</p>
                <ul class="requirement-list">
                    <li> General Risk and Compliance Management:</li>
                    <li class="list-details"> Assess and identify key operational risk, and where there is any material operational risk, propose risk mitigation measures.t</li>
                    <li class="list-details"> Conduct ongoing compliance reviews on line of business to identify any non-compliance issues and track the action plan to close the gap.</li>
                    <li class="list-details"> Monitor changes in market and regulations and update to management on its effects to the enterprise.</li>
                    <li class="list-details"> Review contracts, agreement, MOU, legal documentations or new initiatives and provide inputs and feedback to business unit.</li>
                    <li class="list-details"> Assist manager in preparing administrative documents.</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">AML / CLT Function</p>
                <ul class="requirement-list">
                    <li class="list-details"> Support line of business in customer on-boarding requirements by giving advice and recommendation on the CDD measures.</li>
                    <li class="list-details"> Administering the KYC verification system.</li>
                    <li class="list-details"> Conduct due diligence and ongoing due diligence on partners</li>
                    <li class="list-details"> Monitor transactions to detect suspicious transaction and prepare STR.</li>
                    <li class="list-details"> Collect data to prepare necessary reports or conduct risk assessment as required by regulator.</li>
                    <li class="list-details"> Delivering training to new and existing staff and agents.</li>
                    <li class="list-details"> Carry any other duties as assigned by supervisor or Head of Department.Others.</li>
                    <li class="list-details"> Others.</li>
                    <li class="list-details"> Perform translations of official documents.</li>
                    <li class="list-details"> Prepare documentations to report, request, provide status update or corresponds to regulator’s request</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">How to Apply</p>
                <p class="requirement-list">Interested candidates please submit your CV/resume with a photo and accompanied by cover letter and any other supporting documents to HR Department:</p>
                <div class="hr-contact">
                    <p class="hr-contact-details">Contact Person : HR Department</p>
                    <p class="hr-contact-details">Email: hr@u-pay.com</p>
                    <p class="hr-contact-details">Contact: 069 931 888 / 077 266 123 </p>
                    <p class="hr-contact-details">Website: www.u-pay.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.banner-container {
  position: relative;
  .career-img {
    width: 100%;
  }
  .join-title {
    color: white;
    position: absolute;
    bottom: 3%;
    left: 4%;
    font-size: 2.2rem;
    font-weight: bolder;
  }
}
.job-container {
    display: table;
    margin-right: auto;
    margin-left: auto;
    padding: 3% 25% 3% 25%;
    .title {
        color: #0277E3;
        text-align: center;
        font-size: 1.55rem;
        font-weight: bold;
    }
}

.description-container{
    padding-top: 5%;
    .subtitle {
        color: black;
        text-align: center;
        font-size: 1.35rem;
        font-weight: bold;
    }
    .requirement-list{
        margin: 3% 15% 5% 15%;

        .list-details {
            margin-bottom: 0.5%;
            display: list-item;
            list-style-type: disc;
        }
    }
    .salary{
        font-weight: bolder;
    }

    .hr-contact .hr-contact-details {
        margin-bottom: 3%;
        font-weight: bold;
    }
}

.breadcrumb-container {
    margin : 3% 3%;
}

.breadcrumb-item {
    color: darkgray;
    font-weight: 600;
    font-size: 1.0rem;
}

@media only screen and (max-width: 600px) {
    .job-container {
        display: table;
        margin-right: auto;
        margin-left: auto;
        padding: 3% 5% 3% 5%;
        .title {
            color: #0277E3;
            text-align: center;
            font-size: 1.10rem;
            font-weight: bold;
        }
    }
}
</style>
